import clsx from 'clsx'
import { useState } from 'react'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import { Header } from 'app/KinerjaShared/components/Header'
import {
  useApiGetDokumenAkuntabilitas,
  useApiPostDokumenAkuntabilitas,
} from 'api/kinerja/pengawas-sekolah/pelaksanaan'
import { usePSStatus } from 'app/KinerjaPSPegawaiPage/hooks/useSummary'
import { DOCUMENTS_LIST } from 'app/KinerjaPSPegawaiPage/constants/pelaksanaanTugas'
import { usePPSTrackEvent } from 'app/KinerjaPSPegawaiPage/hooks/usePPSTrackEvent'

export default function PSPelaksanaanPelaksanaanTugas() {
  const toast = useToast()
  const { summary, summaryFetchStatus } = usePSStatus()
  const { trackEvent } = usePPSTrackEvent()

  const [isDokumenTersedia, setIsDokumenTersedia] = useState(false)

  const { status } = useApiGetDokumenAkuntabilitas({
    skpPsId: summary?.skpPsId,
    opts: {
      enabled: summaryFetchStatus === 'success',
      useErrorBoundary: true,
      onSuccess(data) {
        setIsDokumenTersedia(data.dokumenTersedia)
      },
    },
  })

  const { mutateAsync, status: postStatus } = useApiPostDokumenAkuntabilitas({
    skpPsId: summary?.skpPsId,
  })

  const handleCta = async () => {
    try {
      setIsDokumenTersedia(true)

      await mutateAsync({})

      trackEvent('pelaksanaan pegawai', 'submit pelaksanaan tugas')

      toast({
        message: 'Berhasil simpan pernyataan!',
      })
    } catch (error) {
      setIsDokumenTersedia(false)

      console.error(error)

      toast({
        message: 'Gagal simpan pernyataan. Coba lagi.',
      })
    }
  }

  const isLoading = summaryFetchStatus === 'loading' || status === 'loading'

  return (
    <div className="px-3 mx-auto max-w-7xl py-9">
      <Header title="Pelaksanaan Tugas" className="mb-12" />

      <div className="flex gap-8">
        <SimpleCard
          className="p-4 !bg-surface-neutral-subdued flex gap-2 h-fit"
          style={{
            width: '355px',
          }}
        >
          <Icon>information</Icon>

          <div className="pl-8">
            <ul className="list-disc">
              <Text as="li">
                <strong>
                  Pengawas Sekolah tetap menyelesaikan Bukti Dukung Tugas Pokok
                  di luar sistem
                </strong>{' '}
                sesuai peraturan perundang-undangan.
              </Text>
              <Text as="li">
                <strong>
                  Tidak perlu unggah Bukti Dukung di dalam sistem.
                </strong>{' '}
                Cukup tunjukkan Bukti Dukung ke Tim Kinerja dan Pejabat Penilai
                Kinerja.
              </Text>
            </ul>
          </div>
        </SimpleCard>

        <SimpleCard className="flex-1 !rounded mb-24">
          {isLoading && (
            <div
              data-testid="loading-spinner-pelaksanaan-tugas"
              className="flex justify-center w-full p-6"
            >
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <>
              <div className="flex flex-col gap-1 p-6 border-b rounded-t bg-blue-5 border-b-surface-subdued">
                <Text variant="heading-lg">
                  Tekan pernyataan di bawah jika Anda sudah melakukan
                  Pelaksanaan Tugas
                </Text>
              </div>

              <div className="p-6">
                <table
                  cellSpacing="0"
                  className="w-full overflow-hidden border border-separate rounded-lg border-subdued"
                >
                  <thead className="p-4 bg-surface-subdued">
                    <tr>
                      <th className="p-4 text-center w-14">No.</th>
                      <th className="p-4 text-left">Rencana Hasil Kerja</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DOCUMENTS_LIST.map((document, index) => (
                      <tr key={index}>
                        <td
                          className={clsx(
                            'p-4 text-center',
                            index < DOCUMENTS_LIST.length - 1 &&
                              'border-b border-b-disabled'
                          )}
                        >
                          {index + 1}
                        </td>
                        <td
                          className={clsx(
                            'p-4',
                            index < DOCUMENTS_LIST.length - 1 &&
                              'border-b border-b-disabled'
                          )}
                        >
                          <Text variant="body">{document}</Text>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="p-4 mt-4 border rounded-lg border-surface-critical-subdued bg-blue-5">
                  <Checkbox
                    checked={isDokumenTersedia}
                    disabled={isDokumenTersedia || postStatus === 'loading'}
                    onChange={(e) => {
                      if (e.target.checked) {
                        handleCta()
                      }
                    }}
                  >
                    <Text variant="body-bold">
                      Saya menyatakan sudah melakukan Pelaksanaan Tugas
                    </Text>
                  </Checkbox>
                </div>
              </div>
            </>
          )}
        </SimpleCard>
      </div>
    </div>
  )
}
